<template>
	<div>
		<CCard>
			<loader v-show="loading"/>
			<CCardHeader>
				<CCardTitle>
					<h5>Order List</h5>
				</CCardTitle>
			</CCardHeader>
			<CCardBody>
				<div class="table-container">
					<table class="table table-bordered table-striped">
						<thead>
							<tr>
								<th></th>
								<th>Tanggal</th>
								<th>Nama User</th>
								<th>Paket Tryout</th>
								<th>Harga</th>
								<th>Status Pembayaran</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(v, k) in items" :key="k">
								<td><table-number :page="paginator.page" :size="paginator.size" :index="k"/></td>
								<td>{{ v.created_at | dateTimeFormat }}</td>
								<td>{{ v.name }}</td>
								<td>{{ v.label }}</td>
								<td class="right">{{ v.price | thousandSeparator }}</td>
								<td>
									<label v-show="v.order_status_id == 1" class="status pending">Pending</label>
									<label v-show="v.order_status_id == 2" class="status success">Success</label>
									<label v-show="v.order_status_id == 3" class="status failed">Failed</label>

									<label v-show="v.method && v.method.method == 'GP'" class="status gopay">Gopay</label>
									<label v-show="v.method && v.method.method == 'MN'" class="status manual">Manual</label>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</CCardBody>
			<CCardFooter>
				<content-pagination-2 :paginator="paginator" @change="changePage"/>
			</CCardFooter>
		</CCard>
	</div>
</template>
<script>
import Loader from '../../components/Loader'
import ContentPagination2 from '../../components/ContentPagination2'
import { HTTPAUTH } from '../../lib/httplib'
import TableNumber from '../../components/TableNumber'

export default {
	components: {
		Loader,
		ContentPagination2,
		TableNumber,
	},
	data() {
		return {
			items: [],
			paginator: {},
			loading: false,
		}
	},
	created() {
		this.getList(1)
	},
	methods: {
		getList(page) {
			this.loading = true;
			HTTPAUTH.get(`/api/v1/admin/order?page=${page}&size=10`).then(res => {
				this.items = res.data.data;
				this.paginator = res.data.paginate;
				this.$router.push({query: {page: this.paginator.page}});
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			})
		},
		changePage(page) {
			this.getList(page)
		}
	}
}
</script>
